import { __awaiter } from "tslib";
import { resetLag } from "./SchedulerProConfig";
const calculateEventBoundary = (schedulerPro, resource) => {
    let shouldCloseActualEvent = true;
    let allChildrenTrackingDisabled = true;
    let actualEarliestStart = null;
    let actualLatestEnd = null;
    let plannedEarliestStart = null;
    let plannedLatestEnd = null;
    for (const resourceChild of resource.children) {
        const events = schedulerPro.eventStore.getEventsForResource(resourceChild.id);
        const actualEvent = events.find((event) => event.getData("type") === "actual");
        const plannedEvent = events.find((event) => event.getData("type") === "planned");
        if ((!actualEvent && resourceChild.getData("trackingEnabled")) ||
            (actualEvent && actualEvent.getData("active") && resourceChild.getData("trackingEnabled"))) {
            shouldCloseActualEvent = false;
        }
        if (actualEvent) {
            if (!actualEarliestStart || actualEvent.startDate < actualEarliestStart) {
                actualEarliestStart = actualEvent.startDate;
            }
            if (!actualLatestEnd || actualEvent.endDate > actualLatestEnd) {
                actualLatestEnd = actualEvent.endDate;
            }
        }
        if (plannedEvent) {
            if (!plannedEarliestStart || plannedEvent.startDate < plannedEarliestStart) {
                plannedEarliestStart = plannedEvent.startDate;
            }
            if (!plannedLatestEnd || plannedEvent.endDate > plannedLatestEnd) {
                plannedLatestEnd = plannedEvent.endDate;
            }
        }
        if (resourceChild.getData("trackingEnabled")) {
            allChildrenTrackingDisabled = false;
        }
    }
    return {
        shouldCloseActualEvent,
        allChildrenTrackingDisabled,
        actualEarliestStart,
        actualLatestEnd,
        plannedEarliestStart,
        plannedLatestEnd,
    };
};
const updateActualEvent = (schedulerPro, resource, actualEvent, calculatedEventDates) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { eventStore } = schedulerPro;
    const { actualEarliestStart, allChildrenTrackingDisabled, actualLatestEnd, shouldCloseActualEvent, } = calculatedEventDates;
    const eventShouldExist = actualEarliestStart && actualLatestEnd;
    if (eventShouldExist && !actualEvent) {
        return eventStore.applyChangeset({
            added: [
                {
                    type: "actual",
                    resourceId: resource.id,
                    startDate: actualEarliestStart,
                    endDate: actualLatestEnd,
                    active: !shouldCloseActualEvent,
                },
            ],
        });
    }
    if (!eventShouldExist && actualEvent && !allChildrenTrackingDisabled) {
        return eventStore.remove(actualEvent.id);
    }
    if (actualEvent) {
        if (actualEarliestStart && actualLatestEnd) {
            if (((_a = actualEvent.getData("startDate")) === null || _a === void 0 ? void 0 : _a.getTime()) !== actualEarliestStart.getTime()) {
                yield actualEvent.setStartDate(actualEarliestStart, false);
            }
            yield actualEvent.setEndDate(actualLatestEnd);
        }
        actualEvent.set("active", !shouldCloseActualEvent);
    }
});
const updatePlannedEvent = (schedulerPro, resource, plannedEvent, calculatedEventDates) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const { eventStore } = schedulerPro;
    const { plannedEarliestStart, plannedLatestEnd } = calculatedEventDates;
    const eventShouldExist = plannedEarliestStart && plannedLatestEnd;
    if (eventShouldExist && !plannedEvent) {
        return eventStore.applyChangeset({
            added: [
                {
                    type: "planned",
                    resourceId: resource.id,
                    startDate: plannedEarliestStart,
                    endDate: plannedLatestEnd,
                },
            ],
        });
    }
    if (!eventShouldExist && plannedEvent) {
        return eventStore.remove(plannedEvent.id);
    }
    if (plannedEvent) {
        if (plannedEarliestStart && plannedLatestEnd) {
            if (((_b = plannedEvent.getData("startDate")) === null || _b === void 0 ? void 0 : _b.getTime()) !== plannedEarliestStart.getTime()) {
                resetLag(schedulerPro, plannedEvent.id);
                yield plannedEvent.setStartDate(plannedEarliestStart, false);
            }
            yield plannedEvent.setEndDate(plannedLatestEnd);
        }
    }
});
const updateParentEvents = (schedulerPro, resource) => __awaiter(void 0, void 0, void 0, function* () {
    if (resource.isRoot || resource.children.length === 0) {
        return;
    }
    const calculatedEventBoundary = calculateEventBoundary(schedulerPro, resource);
    const events = schedulerPro.eventStore.getEventsForResource(resource.id);
    const actualEvent = events.find((event) => event.getData("type") === "actual");
    const plannedEvent = events.find((event) => event.getData("type") === "planned");
    yield updateActualEvent(schedulerPro, resource, actualEvent, calculatedEventBoundary);
    yield updatePlannedEvent(schedulerPro, resource, plannedEvent, calculatedEventBoundary);
});
export const updateAllParentEvents = (schedulerPro) => __awaiter(void 0, void 0, void 0, function* () {
    const processResource = (resource) => __awaiter(void 0, void 0, void 0, function* () {
        for (const resourceChild of resource.children) {
            yield processResource(resourceChild);
        }
        yield updateParentEvents(schedulerPro, resource);
    });
    yield processResource(schedulerPro.resourceStore.rootNode);
});
export const updateParentEventsForResourceAndItsParents = (schedulerPro, resource) => __awaiter(void 0, void 0, void 0, function* () {
    while (resource && !resource.isRoot) {
        yield updateParentEvents(schedulerPro, resource);
        resource = resource.parent;
    }
});
export const updateParentEventsForDependencies = (schedulerPro, resource) => __awaiter(void 0, void 0, void 0, function* () {
    while (resource && !resource.isRoot) {
        const dependentResources = schedulerPro.dependencyStore.allRecords
            .filter((dependency) => { var _a; return ((_a = dependency.fromEvent) === null || _a === void 0 ? void 0 : _a.resourceId) === resource.id; })
            .map((dependency) => dependency.toEvent.resource);
        for (const dependentResource of dependentResources) {
            yield updateParentEventsForResourceAndItsParents(schedulerPro, dependentResource);
        }
        resource = resource.parent;
    }
});
//# sourceMappingURL=SchedulerProParentEvents.js.map